import { Tenant, Log, LogError } from '@ekuaibao/collection-definition';
import InvoiceRule from './InvoiceRule';
var models = [Tenant, InvoiceRule, Log, LogError];
export default models;
